// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addAdmission input,select{
    width: 350px !important;
}
.addAdmission form{
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}
.addAdmission .add-img{
    max-width: 350px !important;
}
.addAdmission .add-img input{
    width: 267px !important;
}`, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/admission/admission.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,uBAAuB;AAC3B","sourcesContent":[".addAdmission input,select{\n    width: 350px !important;\n}\n.addAdmission form{\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n.addAdmission .add-img{\n    max-width: 350px !important;\n}\n.addAdmission .add-img input{\n    width: 267px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
